import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[viasOnlyNumeric]'
})
export class OnlyNumericDirective {
  private regex = new RegExp(/^[0-9]+([,.]+[0-9]*){0,1}$/g);

  private specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
